import { Component, computed, effect, inject, signal } from '@angular/core';
import { JobStateService } from '../../projects/project/model-new/job-state.store';
import { CachedProjectService } from '../../shared/services/cached-project.service';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { OutputLogsComponent } from './output-logs/output-logs.component';
import { rxResource } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-general-information',
  imports: [CommonModule, NzCardModule, NzDividerModule, NzTagModule, NzIconModule, OutputLogsComponent],
  templateUrl: './general-information.component.html',
  styleUrl: './general-information.component.less',
})
export class GeneralInformationComponent {
  private jobStateService = inject(JobStateService);
  private cachedProjectService = inject(CachedProjectService);

  protected job = computed(() => this.jobStateService.jobData());

  protected iterationCost = computed(() => {
    const job = this.job();
    if (!job?.run_cost || !job?.iterations) return null;
    return job.run_cost / job.iterations;
  });

  protected costType = computed(() => {
    const job = this.job();
    return job?.run_cost_type ?? null;
  });

  protected costTypeColor = computed(() => {
    const type = this.costType()?.toLowerCase();
    if (!type) return 'default';
    if (type.includes('estim')) return 'orange';
    return 'green';
  });

  protected outputLogFiles = rxResource(
    {
      params: () => this.job()?.id ?? null,
      stream: ({params}) => {
        if (!params) return null
        return this.cachedProjectService.getJobOutputLogFiles(params)
      }
    }
  )
}
